import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { signOut } from 'firebase/auth';

import { authUserKey } from '@flintmint/web-shared/hooks/use-auth-user';

import { getFirebaseAuth } from '@/services/firebase-service';

export const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    const clearAndLogout = async () => {
      localStorage.removeItem(authUserKey);

      await signOut(getFirebaseAuth()).catch((error) => console.warn('Firebase sign-out failed:', error));

      await logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    };

    clearAndLogout();
  }, [logout]);

  return <div>Loading...</div>;
};
